import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  useEffect(() => {
    if (user && user.user_id) {
      api.get("/favorites/ids").then(({ data }) => setIds(data)).catch(() => setIds([]));
    } else {
      setIds([]);
    }
  }, [user]);

  const has = useCallback((id) => ids.includes(id), [ids]);

  const toggle = useCallback(async (id) => {
    const { data } = await api.post(`/favorites/${id}`);
    setIds((prev) => (data.favorited ? [...prev, id] : prev.filter((x) => x !== id)));
    return data.favorited;
  }, []);

  return (
    <FavoritesContext.Provider value={{ ids, has, toggle, count: ids.length }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export const useFavorites = () => useContext(FavoritesContext);
